<div class="fxlayout-row-spacearound-center">
  <mat-card style="width: 100%">
    <div class="row-distance" style="padding-left: 10px; display: flex; justify-content: space-between; align-items: center;">

      <app-budget-list-filter></app-budget-list-filter>

    </div>

    <div>
      <mat-tab-group (selectedIndexChange)="selectedTab = $event" [selectedIndex]="selectedTab">

        <mat-tab>
          <ng-template mat-tab-label>
            <span matTooltip="Lista veloce">Budgets list</span>
          </ng-template>

          <app-budget-list-table [queryParamFilter]="queryParamFilter"
          searchMode='quick'></app-budget-list-table>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            @if (performingSlowSearch$ | async) {
              <div class="tab-label-loading">
                <mat-icon matTooltip="Searching...">cloud_sync</mat-icon>
              </div>
            } @else {
              <div class="tab-label-loaded">
                <mat-icon matTooltip="Lista esaustiva ({{slowListElements}} budgets)">cloud_done
                </mat-icon>
                <span>({{ slowListElements }})</span>
              </div>
            }
          </ng-template>

          <app-budget-list-table (updateTotalElements)="slowListElements = $event"
          searchMode='slow'></app-budget-list-table>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <div class="merged-budget-tab" matTooltip="Search for merged budgets">Merged archive ({{ mergedListElements }})</div>
          </ng-template>

          <app-merged-budget-list (updateTotalElements)="mergedListElements = $event"></app-merged-budget-list>
        </mat-tab>
      </mat-tab-group>
    </div>
  </mat-card>
</div>